import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../../organisation/useMe';
import { caseAlertInternalApi } from '../../../apis';
import { FindCaseAlertsPageRequest, InternalApiAlertId } from '../../../api-internal';

export const CASE_ALERTS_QUERY_KEY = 'caseAlerts';

export const useQueryCaseAlertsPage = ({ handle, page, size, orderBy, direction }: FindCaseAlertsPageRequest) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [CASE_ALERTS_QUERY_KEY, 'page', handle, page, size, orderBy, direction, currentOrganisation?.id],
    queryFn: async () => {
      return await caseAlertInternalApi.findCaseAlertsPage({ handle, page, size, orderBy, direction });
    },
    placeholderData: keepPreviousData,
    enabled: !!currentOrganisation?.id && !!handle,
  });
};

export const useAttachCaseAlerts = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, alerts }: { handle: string; alerts: InternalApiAlertId[] }) => {
      return caseAlertInternalApi.attachCaseAlerts({ handle, internalApiAttachCaseAlertsRequest: { alerts } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_ALERTS_QUERY_KEY] });
    },
  });
};

export const useDetachCaseAlerts = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, alerts }: { handle: string; alerts: InternalApiAlertId[] }) => {
      return caseAlertInternalApi.detachCaseAlerts({ handle, internalApiDetachCaseAlertsRequest: { alerts } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_ALERTS_QUERY_KEY] });
    },
  });
};
